var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveToList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "save to list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#1976d2",
    strokeLinecap: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 1.5,
    x2: 15.5,
    y2: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 5.5,
    x2: 15.5,
    y2: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 9.5,
    x2: 6.5,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 13.5,
    x2: 6.5,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 8.5,
    x2: 12.5,
    y2: 14.5,
    stroke: "#1976d2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 11.5,
    x2: 9.5,
    y2: 11.5,
    stroke: "#1976d2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveToList);
export default __webpack_public_path__ + "static/media/save-to-list.afaeeab24071fc423c24a981692e1a77.svg";
export { ForwardRef as ReactComponent };